module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_en_light_large.77a5b3a5.png";